import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "SupplierEnterprisePendingListPage" */
	'pages/supplier/SupplierEnterprise/SupplierEnterprisePendingListPage'));

export default [{ component, exact: true, path: '/supplier_enterprises_pending' }];